var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMetricsQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_809_4735)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.75 2.75L19.25 19.25",
    stroke: "#C1C1C1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bar_chart",
    d: "M5 19C4.45 19 3.97917 18.8042 3.5875 18.4125C3.19583 18.0208 3 17.55 3 17V10C3 9.45 3.19583 8.97917 3.5875 8.5875C3.97917 8.19583 4.45 8 5 8C5.55 8 6.02083 8.19583 6.4125 8.5875C6.80417 8.97917 7 9.45 7 10V17C7 17.55 6.80417 18.0208 6.4125 18.4125C6.02083 18.8042 5.55 19 5 19Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4464",
    d: "M9 5C9 3.89543 9.89543 3 11 3C12.1046 3 13 3.89543 13 5V11L9 7V5Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4467",
    d: "M15 12C15 10.8954 15.8954 10 17 10C18.1046 10 19 10.8954 19 12V17L15 13V12Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4468",
    d: "M16.5 19C15.6716 19 15 18.3284 15 17.5V17L17 19H16.5Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4465",
    d: "M13 17C13 18.1046 12.1046 19 11 19C9.89543 19 9 18.1046 9 17V11L13 15V17Z",
    fill: "#C1C1C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_809_4735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMetricsQuestion);
export default __webpack_public_path__ + "static/media/NoMetricsQuestion.a4430df5929ea4c360d17f3a1499d775.svg";
export { ForwardRef as ReactComponent };